import { createURIs } from '@fortem-monorepo/js-utilities'

export const FORTEM_URIS = createURIs({
  __INDEX__: '/',
  ADMIN: {
    __INDEX__: 'admin',
    STRATEGY: 'strategies',
    FUNDS: 'funds',
    CALENDAR: 'calendar',
  },
  NOTIFICATIONS: 'notifications',
  CALENDAR: 'calendar',
  FEEDS: {
    __INDEX__: 'feeds',
    PROVIDERS: 'providers',
    IC_GUIDELINES: 'ic-guidelines',
  },
  MONITORING: {
    __INDEX__: 'monitoring',
    CUSTOM_JOBS: 'custom-jobs',
    LOGS: 'logs',
  },
  OPERATIONS: {
    __INDEX__: 'operations',
    BATCH_EXECUTOR: 'risk-calibration',
    TX_REPORTING: 'transaction-reporting',
    NAV_UPDATE: 'nav-update',
    AUTOMATED_PRICING: 'automated-pricing',
    MAPPINGS: 'mappings',
    MONTHLY_ROLL: 'monthly-fx-roll',
    NT_HEDGING_FWD: 'nt-hedging-fwd',
    DB_REC: {
      __INDEX__: 'db-rec',
      AUTOMATED_NAV: 'automated-nav',
      POSITIONS_PNL: 'positions-pnl',
    },
    PNL_VALIDATION: 'pnl-validation',
  },
  TRADING: {
    __INDEX__: 'trading',
    NEW_TRADE: 'new-trade',
    BOOKED_TRADES: 'booked-trades',
    BONDS_DATA_REC: 'bonds-data-rec',
    DATA_UPLOAD: 'data-upload',
  },
  FUNDS: {
    __INDEX__: 'funds',
    IC_GUIDELINES: 'ic-guidelines',
    IC_GUIDELINES_V2: 'ic-guidelines-v2',
    IC_REPORT: 'ic-report',
    MANAGEMENT_REPORT: 'management-report',
    FLOWS: 'flows',
  },
  ACCOUNT: {
    __INDEX__: 'account',
  },
  FLOW: {
    __INDEX__: 'flow',
    WEBSITE: 'website',
    RFQ: 'rfq',
    PRICING_MATRIX: 'pricing-matrix',
    POSMON: 'posmon',
    PRICING_INTERFACE: 'pricing-interface',
    CLIENT_PRICING_REPORT: 'client-pricing-report',
    CLIENT_PRICING_REPORT_NEW: 'client-pricing-report-new',
  },
  INSTRUMENTS: {
    __INDEX__: 'instruments',
    NEW_INSTRUMENT: 'new',
    TIME_SERIES: 'time-series',
    MARKETDATA: 'marketdata',
    MARKET_SUMMARY: 'market-summary',
  },
  SALES: {
    __INDEX__: 'sales',
    PERF_REPORT: 'perf-report',
  },
  SMARTRADE: {
    __INDEX__: 'smartrade',
    TRADES: 'trades',
    DATA: 'data',
    CLIENTS: 'clients',
  },
  PM: {
    __INDEX__: 'pm',
    ATTRIBUTIONS: {
      __INDEX__: 'attributions',
      DATA_PRESENCE: 'data-presence',
      RISK_PREMIA: 'risk-premia',
      FIXED_INCOME: 'fixed-income',
      FUND_ATTRIBUTIONS: 'fund-attributions',
    },
    PREMIALAB: {
      __INDEX__: 'premialab',
      DAILY_COMPOSITION: 'daily-composition',
    },
    UPLOAD_TRACK: 'upload-track',
  },
})
